<template>
  <v-icon @click="toggleDrawer" medium class="icon">menu</v-icon>
</template>

<script>
import { actions } from '@/vuex/modules/ui/drawer/constants'
export default {
  name: 'ToggleDrawerButton',
  methods: {
    toggleDrawer() {
      this.$store.dispatch(actions.TOGGLE_DRAWER)
    },
  },
}
</script>

<style lang="scss" scoped>
.icon {
  &:hover {
    border-radius: 50px;
    background: #f2f2f2;
  }
}
</style>
